import Card from "@mui/material/Card"
import CardHeader from "@mui/material/CardHeader"
import CardContent from "@mui/material/CardContent"
import CardActions from "@mui/material/CardActions"
import IconButton from "@mui/material/IconButton"
import MoreVertIcon from "@mui/icons-material/MoreVert"
import { Button, Grid, Menu, MenuItem } from "@mui/material"
import { useState } from "react"
import { Link } from "react-router-dom"
import ToggleOnIcon from '@mui/icons-material/ToggleOn'
import ToggleOffIcon from '@mui/icons-material/ToggleOff'
import { Stack } from "@mui/system"
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee'
import AttachMoneyIcon from '@mui/icons-material/AttachMoney'
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts'
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet"

export default function AccountCard({ data, edit, remove, noView }) {
  const [menu, setMenu] = useState(null)
  const openMenu = (event) => setMenu(event.currentTarget)
  const closeMenu = () => setMenu(null)

  return (
    <Card
      elevation={0}
      sx={{
        justifyContent: "space-between",
        maxHeight: "44vh",
        height: "100%",
        borderRadius: { sm: 8 },
        boxShadow: "10px 10px 74px -37px rgba(0,0,0,0.3)",
        p: { sm: 2 },
      }}
    >
      <CardHeader
        action={
          <IconButton onClick={openMenu}>
            <MoreVertIcon />
          </IconButton>
        }
        title={data?.accountName}
      />

      <CardContent sx={{ py: 0 }}>
        {/* <Typography variant="body1" color="text.secondary">
            {data.code}
        </Typography> */}
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <Stack
              direction="row"
              alignItems="center"
              style={{ color: "gray" }}
              gap={1}
            >
              {data?.currency !== "INR" ? <AttachMoneyIcon /> : <CurrencyRupeeIcon />} {data?.totalBalance}
            </Stack>
          </Grid>
          <Grid item xs={6}>
            <Stack
              direction="row"
              alignItems="center"
              style={{ color: "gray" }}
              gap={1}
            >
              <ManageAccountsIcon /> {data?.owner_?.name}
            </Stack>
          </Grid>
          <Grid item xs={6}>
            <Stack
              direction="row"
              alignItems="center"
              style={{ color: "gray" }}
              gap={1}
            >
              <AccountBalanceWalletIcon /> {data?.type}
            </Stack>
          </Grid>

          <Grid item xs={6}>
            <Stack
              direction="row"
              alignItems="center"
              style={{ color: "gray" }}
              gap={1}
            >
              {data?.status === "ACTIVE" ? <ToggleOnIcon /> : <ToggleOffIcon />} {data?.status}
            </Stack>
          </Grid>
        </Grid>
      </CardContent>

      {!noView && (
        <CardActions>
          <Link style={{ width: "100%" }} to={`/accounting/accounts/${data?.id}`}>
            <Button
              variant="contained"
              fullWidth
              sx={{ borderRadius: { sm: 8 } }}
              disableElevation
            >
              View Transfers
            </Button>
          </Link>
        </CardActions>
      )}

      <Menu anchorEl={menu} open={Boolean(menu)} onClose={closeMenu}>
        <MenuItem
          onClick={() => {
            edit()
            closeMenu()
          }}
        >
          Edit
        </MenuItem>
        <MenuItem
          onClick={() => {
            remove()
            closeMenu()
          }}
        >
          Delete
        </MenuItem>
      </Menu>
    </Card>
  )
}
